module.exports = __webpack_public_path__ + "img/palaze_logo_icon.97db943b.png";